import React from "react";
import CloseIcon from "images/icons/close.inline.svg";

const WhatsExcluded = ({ whatsExcluded, groupsWhatsExcluded }) => {
  return (
    <>
      <div className="flex flex-col justify-center h-full pt-4 bg-transparent">
        <div className="w-full rounded-sm mx-autoshadow-lg">
          <div className="overflow-x-auto">
            <table className="w-full table-auto">
              <thead className="text-base font-semibold text-black-lighter dark:text-white border-b-[1px] border-light dark:border-b-gray-light">
                <tr>
                  <th className="w-4/5 pb-4 whitespace-nowrap">
                    <div className="font-semibold text-left">Not included</div>
                  </th>
                  {groupsWhatsExcluded.length > 1 ? (
                    <>
                      <th className="whitespace-nowrap w-[10%]">
                        <div className="font-semibold text-right">Groups</div>
                      </th>
                    </>
                  ) : (
                    <></>
                  )}
                </tr>
              </thead>
              <tbody className="text-base divide-y">
                {groupsWhatsExcluded.length > 1
                  ? groupsWhatsExcluded.map(({ excludeItem }) => (
                      <tr
                        key={`${excludeItem}-id`}
                        className="text-black-lighter dark:text-gray-generic !border-0"
                      >
                        <td className="pt-4 border-0">{excludeItem}</td>
                        <td className="pt-4 pr-5 border-0">
                          <CloseIcon className="w-3 h-3 stroke-black-lighter dark:stroke-white float-right" />
                        </td>
                      </tr>
                    ))
                  : whatsExcluded.map(({ excludeItem }) => (
                      <tr
                        key={`${excludeItem}-id`}
                        className="text-black-lighter dark:text-gray-generic !border-0"
                      >
                        <td className="pt-4 border-none">{excludeItem}</td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatsExcluded;
